import React from "react";
import { changePassword } from "../../../api/recruiterUsersApi";

function ChangePasswordForm() {
  return (
    <div className="flex flex-col mx-0 md:mx-0 lg:mx-0 md:flex-row md:mb-10 lg:mb-10 mb-5 md:w-full  lg:w-full w-full  rounded-lg bg-[#F4F4F4]">
      <div className="w-full ">
        <h2 className="text-xl font-semibold mt-5 md:ml-6 pl-2 lg:ml-4 ml-2 text-gray-700 mb-4">
          Change Password
        </h2>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            const user = JSON.parse(localStorage.getItem("user"));
            const currentPassword = e.target.currentpassword.value;
            const newPassword = e.target.newpassword.value;
            const confirmPassword = e.target["confirm-password"].value; // Extract Re-enter New Password

            // Validation: Ensure current password and new password are not the same
            if (currentPassword === newPassword) {
              alert("New password cannot be the same as the current password.");
              return; // Prevent submission if validation fails
            }

            // Validation: Ensure new password and re-entered password match
            if (newPassword !== confirmPassword) {
              alert("New password and re-entered password must match.");
              return; // Prevent submission if validation fails
            }

            const body = {
              mail: user.mail,
              oldPassword: currentPassword,
              newPassword: newPassword,
            };
            const res = await changePassword(body);
            if (res.status === 200) {
              alert("Password Changed Successfully");
            } else {
              alert(res.body?.message || res.message);
            }
          }}
        >
          <div className="grid grid-cols-1 px-2 md:grid-cols-3 lg:grid-cols-3 md:ml-6 lg:ml-4 ml-2 md:gap-0 lg:gap-0 gap-4">
            <div>
              <label className="block text-gray-600 mb-1 px-1">
                Enter Current Password
              </label>
              <input
                required
                id="currentpassword"
                type="password"
                className="md:w-[27vw] lg:w-[27vw]  w-full border border-gray-300 rounded-lg md:px-4 lg:px-4 px-4 py-2"
              />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">
                Enter New Password
              </label>
              <input
                required
                type="password"
                id="newpassword"
                className="md:w-[27vw] lg:w-[27vw] w-full border border-gray-300 rounded-lg md:px-4 lg:px-4 px-4 py-2"
              />
            </div>
            <div>
              <label
                htmlFor="confirm-password"
                className="block text-gray-600 mb-1"
              >
                Re-Enter New Password
              </label>
              <input
                required
                id="confirm-password"
                type="password"
                className="md:w-[27vw] lg:w-[27vw] w-full border border-gray-300 rounded-lg md:px-4 lg:px-4     px-4 py-2"
              />
            </div>
          </div>

          <div className="flex items-center bg-[#E7E7E7] justify-end rounded-lg mt-10 p-4">
            <button
              type="submit"
              className="bg-black text-white px-10 py-2 rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-600"
            >
              Change Password
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangePasswordForm;
